export const EnviarMensajeStyles = 
{
  'input': {
    width: '75%',
    height: '37px',
    borderRadius: '50px',
    border: '1px solid #C5C5C5',
    fontSize:'16px',
    "&:focus": {
      outline:'none',
      fontSize:'16px',
      outlineWidth: '0',
      boxShadow: 'none'
    }
  },
  'button':{
    borderRadius:'50px',
    color:'#FFFFFF',
    fontSize:'10px',
    backgroundColor:'#026AB8',
    textTransform: 'capitalize' as 'capitalize',
    cursor: 'pointer',
    "&:hover":{
      color:'#1c1c1d',
      backgroundColor: '#a2a2a9'
    }
  },

  'sendmobile':{
    paddingRight: '12px'
  }
}